<template>
    <div class="center-box flex flex-direction">
        <title1 title="运营趋势" :isBg="false" fontSize="32" />
        <div
            v-for="(item, i) in target1"
            :key="'target1' + i"
            class="flex align-center target4"
            :class="{'hidden': pathName == 'changingElectricityMerge' && i == 4}">
            <img class="img" :src="item.icon" />
            <div class="flex flex-direction flex1">
                <div class="label">{{ item.label}}</div>
                <div class="num flex align-center fs-center" :style="{'color': item.color}">
                    <slot v-if="item.overTenThousand">{{ item.number | overTenThousandUnit }}</slot>
                    <slot v-else>{{ item.number }}</slot>
                </div>
                <!-- <dv-digital-flop class="num" :config="dvDigitalFlopConfig(item)" /> -->
            </div>
        </div>
        <!-- <div class="flex flex-wrap justify-between">
            <div
                v-for="(item, i) in target1"
                :key="'target1' + i"
                class="flex flex-direction align-center target1 mt-30 width-50">
                <span class="label1">{{ item.number }}</span>
                <img class="img1" :src="require('@/assets/images/exposition/chd-bg-2.png')" alt="">
                <span class="num1">{{ item.label }}</span>
            </div>
        </div>
        <title1 class="mt-30" type="2" title="运营布局" />
        <div class="flex align-center">
            <span class="sub-title">充电</span>
            <div
                v-for="(item, i) in target2"
                :key="'target1' + i"
                class="flex flex-direction align-center target2 mt-30 width-50">
                <span class="label1">{{ item.number }}</span>
                <img class="img1" :src="require('@/assets/images/exposition/chd-bg-3.png')" alt="">
                <span class="num1">{{ item.label }}</span>
            </div>
        </div>
        <div class="flex align-center">
            <span class="sub-title">换电</span>
            <div
                v-for="(item, i) in target3"
                :key="'target1' + i"
                class="flex flex-direction align-center target2 mt-30 width-50">
                <span class="label1">{{ item.number }}</span>
                <img class="img1" :src="require('@/assets/images/exposition/chd-bg-3.png')" alt="">
                <span class="num1">{{ item.label }}</span>
            </div>
        </div> -->
    </div>
</template>

<script>
import title1 from '@/views/exposition/components/title1'
import { dataInterface } from '@/api/dataInterfaceApi'
export default {
    props: {},
    watch: {},
    components: {
        title1
    },
    data() {
        return {
            pathName: this.$route.name,
            target1: [
                {
                    icon: require('@/assets/images/exposition/chd-12.png'),
                    number: '',
                    label: '活跃用户数(人)',
                    color: '#36FBFB'
                },
                {
                    icon: require('@/assets/images/exposition/chd-9.png'),
                    number: '',
                    label: '活跃车辆数(辆)',
                    color: '#43FFB9'
                },
                {
                    icon: require('@/assets/images/exposition/chd-17.png'),
                    number: '',
                    label: '用户粘性(%)',
                    color: '#FFFFFF'
                },
                {
                    icon: require('@/assets/images/exposition/chd-10.png'),
                    number: '',
                    label: '车辆粘性(%)',
                    color: '#179DFF'
                },
                {
                    icon: require('@/assets/images/exposition/chd-16.png'),
                    number: '',
                    label: '上线城市',
                    color: '#36FBFB'
                },
            ],
        }
    },
    methods: {
        dvDigitalFlopConfig(item = {}) {
            let number = item.number || 0
            let config = {
                number: [parseInt(number > 10000 ? (number / 10000) : number)],
                textAlign: item.textAlign || 'left',
                style: {
                    fill: item.color || '#fff',
                    fontSize: item.fontSize || 60,
                }
            }
            return config
        },
		getData(data) {
            this.yunyingqushi1(data)
            this.yunyingqushi2(data)
            // this.yunyingqushi2(data, 1)
        },
        yunyingqushi1(data = {}) {
            let province = data.province || data.city || data.district || '000000'
			let params = {
				'enCode': 'TiDB-xiazuan-yunyingqushi',
                '@ADCODE': province
			}
			dataInterface.dataFaceApi(params).then((res) => {
				if (!res) return
				let data = res && res[0] || {}
                this.target1[0].number = data.vehicleAvtiveNum
                this.target1[1].number = data.userActiveNum
                this.target1[2].number = data.vehicleViscidity
                this.target1[3].number = data.userViscidity
			})
			.catch((err) => {
				console.log(err);
			});
		},
        yunyingqushi2(data = {}) {
            let province = data.province || data.city || data.district || '000000'
			let params = {
				'enCode': 'TiDB-xiazuan-yunying',
                '@station_type': '全部', //type == 1 ? '换电站' : '充电桩',
                '@ADCODE': province
			}
			dataInterface.dataFaceApi(params).then((res) => {
				if (!res) return
				let data = res && res[0] || {}
                this.target1[4].number = data.total_city_num
                // if(type) {
                // } else {
                //     this.target2[0].number = data.total_city_num
                // }
			})
			.catch((err) => {
				console.log(err);
			});
		},
    }
}
</script>

<style lang="scss" scoped>
@import '../scss/chd-com.scss';
</style>